import {
	ChangeDetectionStrategy,
	Component,
	computed,
	effect,
	ElementRef,
	inject,
	input,
	untracked,
	viewChild,
	viewChildren,
} from '@angular/core';

import { SourcePreviewService } from '~ng-common-lib/source-preview/services/source-preview.service';
import { SourcePreviewByNodeSource } from '~ng-common-lib/source-preview/types/source-preview-input';

@Component({
	selector: 'source-preview-with-sources',
	templateUrl: './preview-with-sources.component.html',
	changeDetection: ChangeDetectionStrategy.OnPush,
	standalone: true,
	imports: [],
	host: {
		class: 'block',
		style: '--spacing: 8px',
	},
})
export class SourcePreviewWithSourcesComponent {
	private readonly sourcePreviewService = inject(SourcePreviewService);

	public readonly $showContent = input(true, { alias: 'showContent' });
	public readonly $sources = input.required<SourcePreviewByNodeSource[]>({ alias: 'sources' });

	protected readonly $contentWrapper = viewChild<unknown, ElementRef<HTMLElement>>(
		'contentWrapper',
		{
			read: ElementRef,
		}
	);
	protected readonly $sourceCards = viewChildren<unknown, ElementRef<HTMLElement>>('sourceCard', {
		read: ElementRef,
	});

	protected readonly $scrollMargin = computed(() => {
		const contentWrapper = this.$contentWrapper()?.nativeElement;
		const wrapperHeight = contentWrapper?.clientHeight ?? 0;

		if (wrapperHeight === 0) {
			return `0px`;
		}

		return `calc(${wrapperHeight}px + var(--spacing))`;
	});

	constructor() {
		effect(() => {
			const cards = this.$sourceCards();
			const selectedSource = this.sourcePreviewService.$selected()?.sourceId ?? null;

			untracked(() => {
				const card = cards.find((card) => {
					return card.nativeElement.getAttribute('data-id') === selectedSource;
				});

				card?.nativeElement.scrollIntoView({ behavior: 'smooth', block: 'start' });
			});
		});
	}
}
